/* eslint-disable
    default-case,
    eqeqeq
*/
// TODO: This file was created by bulk-decaffeinate.
/*
 * decaffeinate suggestions:
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import ApiError from 'app/scripts/network/api-error';
import Promise from 'bluebird';
import SessionStorage from 'app/scripts/lib/session-storage';
import _ from 'underscore';
import f from 'effing';
import assert from 'app/scripts/lib/assert';
import { featureFlagClient } from '@trello/feature-flag-client';
import { isMeAlias } from 'app/scripts/lib/util/url/isMeAlias';

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}

export const userOrOrgRoutes = {
  routes: [
    [':name/account', 'userOrOrgAccountView'],
    [':name/profile', 'userOrOrgCheckTreehouseProfileFlag'],
    [':name/billing(?*query)', 'userOrOrgBillingView'],
    [':name/billing/card', 'userOrOrgBillingCardView'],
    [':name/billing/card/:product', 'userOrOrgBillingCardView'],
    [':name/cards', 'userOrOrgCardView'],
    [':name/cards/:pageName', 'userOrOrgCardView'],
    [':name(/)', 'userOrOrgProfileView'],
  ],

  userOrOrgCheckTreehouseProfileFlag(name) {
    if (!featureFlagClient.get('treehouse.web.profile-redesign')) {
      this.userOrOrgAccountView(name);
    } else {
      this.userOrOrgProfileView(name);
    }
  },

  userOrOrgProfileView(name) {
    if (name == null) {
      name = 'me';
    }

    if (featureFlagClient.get('treehouse.web.profile-redesign')) {
      const ModelCache = require('app/scripts/db/model-cache');
      const Auth = require('app/scripts/db/auth');

      if (!Auth.isLoggedIn()) {
        this.userOrOrgView(
          name,
          this.memberActivityView,
          this.organizationBoardsView,
        );
      } else {
        ModelCache.waitFor('Member', Auth.myId(), (__, me) => {
          if (me.get('username') === name || isMeAlias(name)) {
            this.userOrOrgView(
              name,
              this.memberProfileView,
              this.organizationBoardsView,
            );
          } else {
            this.userOrOrgView(
              name,
              this.memberActivityView,
              this.organizationBoardsView,
            );
          }
        });
      }
    } else {
      this.userOrOrgView(
        name,
        this.memberProfileView,
        this.organizationBoardsView,
      );
    }
  },

  userOrOrgAccountView(name) {
    if (name == null) {
      name = 'me';
    }
    this.userOrOrgView(
      name,
      this.memberAccountView,
      this.organizationAccountView,
    );
  },

  // Billing views
  userOrOrgBillingView(name) {
    let escapedReturnUrl;
    if (name == null) {
      name = 'me';
    }
    let returnUrl =
      (escapedReturnUrl = __guard__(
        /returnUrl=([^&]+)/.exec(location.search),
        (x) => x[1],
      )) != null
        ? decodeURIComponent(escapedReturnUrl)
        : undefined;
    if (!/^\/($|[a-zA-Z0-9])/.test(returnUrl)) {
      returnUrl = undefined;
    }

    this.userOrOrgView(
      name,
      this.memberBillingView,
      this.organizationBillingView,
      { returnUrl },
    );
  },

  userOrOrgBillingCardView(name, product) {
    if (name == null) {
      name = 'me';
    }
    this.navigate([name, 'billing'].join('/'), {
      replace: true,
      trigger: true,
    });
  },

  userOrOrgCardView(name, pageName) {
    if (name == null) {
      name = 'me';
    }
    return this.userOrOrgView(
      name,
      this.memberCardsView,
      this.memberHomeCardsView,
      { pageName },
    );
  },

  getViewData(name) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    let value;
    const ApiPromise = require('app/scripts/network/api-promise');

    const key = `typeof_${name}`;

    // Check cache for item
    if ((value = SessionStorage.get(key)) != null) {
      return Promise.resolve(value);
    } else {
      return ApiPromise({ url: `/1/types/${name}` }).tap(
        f(SessionStorage, 'set', key),
      );
    }
  },

  userOrOrgView(name, fxUser, fxOrganization, options) {
    if (options == null) {
      options = {};
    }
    return this.getViewData(name)
      .then((data) => {
        const fn = (() => {
          switch (data.type) {
            case 'member':
              return fxUser;
            case 'organization':
              return fxOrganization;
          }
        })();

        assert(fn != null, `/1/types/${name} resolved to ${data.type}`);
        return fn.call(this, name, options);
      })
      .catch(ApiError.NotFound, () => {
        return this.displayErrorPage();
      })
      .done();
  },
};
